<template>
  <div class="grid gap-2 grid-cols-2 md:grid-cols-3">
    <label
      v-for="option in props.options"
      :key="option.value"
      class="cursor-pointer flex items-center gap-2"
    >
      <input
        type="checkbox"
        class="checkbox checkbox-sm"
        :value="option.value"
        :checked="safeModel.includes(option.value)"
        @change="toggleOption(option.value)"
      />
      <span class="label-text">{{ option.label }}</span>
    </label>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  modelValue?: string[];
  options: { label: string; value: string }[];
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: string[]): void;
}>();

const safeModel = computed(() => props.modelValue ?? []);

function toggleOption(val: string) {
  const current = safeModel.value;
  const newValue = current.includes(val)
    ? current.filter((v) => v !== val)
    : [...current, val];
  emit("update:modelValue", newValue);
}
</script>
